import { put, takeLatest } from '@redux-saga/core/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { getPlacementEditableStatuses } from '../../../../../services/PlacementServices/PlacementServices';
import { trackPromise } from 'react-promise-tracker';
import { call, select } from 'redux-saga/effects';
import { pageAttributesActions } from './placementPageAttributes.redux';
import { trackException } from 'app-insights/appInsightsTracking';
import { ExceptionType } from 'app/enums/Common';
import { selectPlacementConsolidatedDetails } from 'store/redux-store/placement-summary/consolidatedStoreSelectors';

const TrackEditableStatusWrapper = (fn, ...args) => trackPromise(fn(...args), 'editable-field-status');

export function* requestEditableStatuses(action: PayloadAction<{ placementId: number, isInitLoad?: boolean  | false }>) {
  try {
    let response;
    const consolidatedDetails = yield select(selectPlacementConsolidatedDetails);
    if(action.payload.isInitLoad && consolidatedDetails){
      response = consolidatedDetails.common?.disabledFields?.data
    }

    if(!response?.status || !response?.data){
      response = yield call(TrackEditableStatusWrapper, getPlacementEditableStatuses, action.payload.placementId);
    }
    
    if (response) yield put(pageAttributesActions.setEditableStatuses(response));
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.APIRequestError,
        functionName: 'requestEditableStatuses',
        area: 'src/app/components/Placement/PlacementDetails/Edit/store/placementPageAttributes.saga.ts',
      },
    });
  }
}

export function* pageAttributesSaga() {
  yield takeLatest(pageAttributesActions.getEditableStatusesAction.type, requestEditableStatuses);
}
